/**
 * Check if a user has admin-level access (admin or platform_admin)
 */
export const isAdminRole = (role) => role === 'admin' || role === 'platform_admin';

/**
 * Check if a user has instructor-level access (instructor, admin, or platform_admin)
 */
export const isInstructorOrAbove = (role) => role === 'instructor' || isAdminRole(role);
